export default "https://assets.egbcdn.net/assets/packs/_/images/hidden_temple_en-e9906cf209b05e3efa7341a14510cdf6.jpg";